import React from "react";
import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../../tek.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'
import chiic from "assets/img/chiic.png";

import Headerbutton from "../../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function StepTekSeven(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} =props;

    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }
    return (

      <div className={"containerStartTekTwo wrapper history tek-page-comic"}
           style={{backgroundImage: `url(${t("tek.itin4.comicintro5")})`}}
      >
              <div className={"insideTek boxed"}>
                  <Headerbutton  saveAndContinue={saveAndContinue}  />
              </div>
              <div className={"container-history boxed"}>
                  <div className={"container-dialogue container-dialogue--no-text"}>
                      <div className={"dialogue-buttons"}>
                          <div className="left margin-right-auto">
                              <Button
                                icon={<LeftOutlined />}
                                type={"link"}
                                onClick={() => props.goTo(7)}
                              >
                                  {t("atras")}
                              </Button>
                          </div>
                          <div className="right">
                              <Button icon={<ArrowRightOutlined />}
                                      onClick={() =>  history.push("/admin/tek-instructions")}
                                      type={"primary"}
                                      className="primaryButton"
                              >
                                  {t("next")}
                              </Button>
                          </div>
                      </div>
                  </div>
            </div>
        </div>

    )
}

export default withTranslation()(StepTekSeven);
